import React, { useState, useEffect } from 'react';
import {
  Button,
  Col,
  Container,
  Dropdown,
  Image,
  Modal,
  Row
} from 'react-bootstrap';
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import QRCode from "react-qr-code";

import { 
  HiDotsCircleHorizontal,
  HiOutlineChevronLeft,
  HiPlusCircle
} from "react-icons/hi";

import { 
  IoArrowUndoCircle,
  IoQrCodeSharp
} from "react-icons/io5";

import InvoiceDetail from '../../components/Invoice';
import * as formatter from '../../helpers/formatting';
import useUser from '../../hooks/useUser';
import GetInvoiceAction from '../../actions/GetInvoiceAction';

export default function Invoice(data) {
  const { user } = useUser();
  const navigate = useNavigate();
  const { invoiceId } = useParams();

  // state
  const [invoice, setInvoice] = useState("");
  const [invite, setInvite] = useState("");
  const [disableRefund, setDisableRefund] = useState(true);
  const [showAlertError, setShowAlertError] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  useEffect(() => {
    async function fetchInvoice() {
      const response = await GetInvoiceAction(user.token, invoiceId);
      if(!!response.data) {
        setInvoice(response.data);
        setInvite(response.data.invite.data);
        setDisableRefund(response.data.status == 'sent')
      } else {
        setShowAlertError(true);
      }
    }
    fetchInvoice();
  }, []);  

  return (
    <>
      <Container className="content-body g-0 text-start">
        <Row>
          <Col>      
            { showAlertError && 
              <Alert severity="error" icon={false} className="alert">
                <AlertTitle>Error retrieving invoice</AlertTitle>
              </Alert>
            }
            { !showAlertError &&  
              <InvoiceDetail
                showHistory={ true } 
                invoiceData={ invoice } 
              />
            }
          </Col>
        </Row>
      </Container>
      <Container className="mt-auto footer-toolbar fixed-bottom">
        <Row>
          <Col>
            <Dropdown  drop="up">
              <Dropdown.Toggle as={ Button } variant="link" className="text-decoration-none">
                <IoArrowUndoCircle className="toolbar-icon" />Cancel &nbsp;
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Update and reissue</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item disabled={ disableRefund } onClick={()=>setShowReverseModal( true )}>Reverse Charges</Dropdown.Item> {/* Disabled if customer has not paid */}
                <Dropdown.Divider />
                <Dropdown.Item onClick={()=>setShowCancelModal( true )}>Cancel completely</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Modal
              show={showCancelModal}
              onHide={() => setShowCancelModal(false)}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Cancellation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Clicking 'Confirm' will close this invoice with no pending payments transferred. 
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={() => setShowCancelModal(false)}>Confirm</Button>
              </Modal.Footer>
            </Modal>   
            <Modal
              show={showReverseModal}
              onHide={() => setShowReverseModal(false)}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Reverse Charges</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Clicking 'Confirm' will reverse charges to the customer and any payment already received. 
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowReverseModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={() => setShowReverseModal(false)}>Confirm</Button>
              </Modal.Footer>
            </Modal>
          </Col>
          <Col>
            <Button onClick={()=>setShowQrModal( true )} variant="link" className="text-decoration-none">
              <IoQrCodeSharp className="toolbar-icon" />QR Code
            </Button>
            <Modal
              size="lg"
              show={showQrModal}
              onHide={() => setShowQrModal(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  Scan to Pay
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container className="g-0 text-center">
                  <Row>
                    <Col />
                    <Col xs={12} sm={8}>
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={ 'https://www.meetbeep.com/' + invite.invite_code }
                        viewBox={`0 0 256 256`}
                      />  
                      <h3 className="mt-3">{ formatter.formatCurrency(invoice.amount) }</h3>
                      <div><small>invoiced to</small></div>
                      <div>{ invoice.customer_name }</div>
                    </Col>
                    <Col />
                  </Row>  
                </Container>
              </Modal.Body>
            </Modal>
          </Col>
        </Row>
      </Container>
    </>
  )
}